var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',{staticClass:"margin-top-20 publish-button-con",staticStyle:{"background":"#fff"}},[_c('FormItem',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }